<template>
  <picture>
    <source
      media="(max-width: 750px)"
      :srcset="mobileBackground"
    >
    <img
      :src="desktopBackground"
      loading="lazy"
    >
  </picture>
</template>

<script>
export default {
  props: {
    desktopBackground: {
      type: String,
      required: true,
    },
    mobileBackground: {
      type: String,
      required: true,
    },
  },
}
</script>
